<template>
  <div class="cmp-distribution-orders-order_list dt-page">
    <EdiOrderList
      :loadingFlag="loadingEdiFlag"
      :selectedEdiOrderTab="selectedEdiOrderTab"
      @load="onEdiListLoad"
      v-if="showEdiOrderList"
    />
    <div v-else>
      <div class="dt-page--top-bar v1">
        <div class="dt-page--add-button">
          <div class="dt-icon-container">
            <img
              @click="onAddOrderClick"
              class="dt-icon v5 s1"
              src="static/buttons/add.svg"
              alt
            />
          </div>
        </div>
        <div class="search">
          <InputField
            :value="basicFilter.searchString"
            :placeholder="$t('search')"
            :config="{
              borderStyle: 'bottom',
              maxWidth: '200px',
              minWidth: '200px',
              width: '200px',
            }"
            @keyup="onSearchInputKeyup"
          ></InputField>
          <DTIconButton
            :classNames="'search--advanced'"
            :text="$t('advanced_search')"
            :style="{
              minWidth: '148px',
              maxWidth: '148px',
            }"
            icon="add-blue"
            @click="onAdvancedSearchClick"
          />
        </div>

        <Dropdown
          :style="{ maxWidth: '155px', width: '155px !important' }"
          :options="accountsTV"
          :selected="accountsTV.find((e) => e.value == basicFilter.account_id)"
          :placeholder="$t('select_account')"
          deselect
          borderbottom
          v-on:selectedChange="(e) => onDropdownChange('account_id', e)"
        >
        </Dropdown>

        <Dropdown
          :style="{ maxWidth: '135px', width: '135px !important' }"
          :options="orderStatusTV"
          :selected="orderStatusTV.find((e) => e.value == basicFilter.status)"
          :placeholder="$t('select_status')"
          deselect
          borderbottom
          v-on:selectedChange="(e) => onDropdownChange('status', e)"
        >
        </Dropdown>

        <!-- <Dropdown 
          :style="{ maxWidth: '190px', width: '190px !important' }"
          :options="monthsTV" 
          :selected="monthsTV.find(e=>e.value==basicFilter.order_month)" 
          :placeholder="'Select Month'" 
          deselect borderbottom v-on:selectedChange="(e) => onDropdownChange('order_month', e)"
        >
        </Dropdown> -->

        <Dropdown
          :style="{ maxWidth: '175px', width: '175px !important' }"
          :options="accountedList"
          :selected="
            accountedList.find((e) => e.value == basicFilter.accounted_period)
          "
          :placeholder="'Select Accounted'"
          deselect
          borderbottom
          v-on:selectedChange="(e) => onDropdownChange('accounted_period', e)"
        >
        </Dropdown>

        <!-- <DatePicker2
          id="shipping_date"
          :showLabel="false"
          :value="basicFilter.shipping_date"
          @input="onDateChange"
          lw="70px"
          cw="110px"
          :hoverStyle="1"
          :placeholder="'Del Date'"
        />

        <Dropdown
          :style="{ maxWidth: '150px', width: '150px !important' }"
          :options="shippedList"
          :selected="shippedList.find((e) => e.value == basicFilter.is_shipped)"
          :placeholder="'Select Shipped'"
          deselect
          borderbottom
          v-on:selectedChange="(e) => onDropdownChange('is_shipped', e)"
        >
        </Dropdown> -->
        <div v-if="displayLoadEdiOrdersBtn" class="right-container ut-colcen">
          <div class="ut-flex">
            <button class="dt-button v5 s8" @click="onEdiListLoad(true)">
              {{ $t("Edi List") }}
            </button>
          </div>
        </div>
      </div>
      <div class="dt-page--2nd-bar" v-if="isSearchFilterActive">
        <div class="search-config--container">
          <div class="search-config">
            <SearchConBadge
              v-for="sconKey of filteredAdvancedSearchConfigKeys"
              :key="sconKey"
              v-bind="searchConfigKey(sconKey)"
              @delete="onSearchConDelete"
            />
          </div>
        </div>
      </div>
      <div
        class="dt-page--body"
        :style="{ '--offset': `${isSearchFilterActive ? `156px` : `120px`}` }"
      >
        <NTable
          :id="'distribution-orders-order_list'"
          :headers="headers"
          :items="list"
          class="order_list h1"
          :config="orderTableConfig"
          :loadingFlag="loadingFlag"
          @scrollnext="onListScroll"
        >
          <template v-slot:item="{ item, tdcon }">
            <tr
              :class="{
                selected: selectedRow(item),
              }"
            >
              <td @click="onRowClicked(item)" v-bind="tdcon('order_date')">
                <span style="font-weight: bold">{{ item["order_date"] }}</span>
              </td>
              <td v-bind="tdcon('order_id')">
                <div class="ut-flex">
                  <div>{{ item["order_id"] }}</div>
                  &nbsp;
                  <div>{{ item["order_type_name"] }}</div>
                </div>
              </td>
              <td v-bind="tdcon('account_name')">
                <span class="txtov">{{ item["account_name"] }}</span>
              </td>
              <td v-bind="tdcon('reference')">
                <span class="txtov">{{ item["order_reference"] }}</span>
              </td>

              <td v-bind="tdcon('status1')">
                <span>{{ item["status"] }}</span>
              </td>
              <td v-bind="tdcon('source')">
                <span class="txtov" :title="item['order_source']">{{
                  item["order_source"]
                }}</span>
              </td>
              <td v-bind="tdcon('account_date')">
                <div class="ut-flex">
                  <div style="min-width: 20px">
                    <div class="dt-checkbox v2 s1 disabled2">
                      <input
                        type="checkbox"
                        :name="'paid_flag'"
                        :id="'paid_flag'"
                        :checked="item['accounted_date']"
                        :disabled="true"
                      />
                      <div class="checkmark"></div>
                    </div>
                  </div>
                  <div style="flex: 1; margin-left: 4px">
                    <span v-if="item['accounted_date']">{{
                      item["accounted_date"]
                    }}</span>
                  </div>
                </div>
              </td>
              <td v-bind="tdcon('invoice')">
                <span
                  class="ut-link ut-text-accent5"
                  @click.stop="(e) => onClickInvoiceRef(item)"
                  >{{ item["invoice_ref"] }}</span
                >
              </td>
              <td v-bind="tdcon('order_value')">
                <div class="ut-flex ut-jend">
                  <div>
                    {{ item["order_value"] }}
                  </div>
                  <div style="width: 25px; max-width: 25px; margin-left: 5px">
                    {{ item["currency_iso"] }}
                  </div>
                </div>
              </td>
              <td v-bind="tdcon('options')">
                <span @click="onShipmentClick" class="ut-link ut-text-accent5">
                  {{ shipmentSettingsKey }}
                </span>
              </td>
              <td v-bind="tdcon('ready_to_ship')">
                <div class="ut-rowcen">
                  <div class="dt-checkbox v2 s1">
                    <input
                      type="checkbox"
                      :name="'ready_to_ship'"
                      :id="'ready_to_ship'"
                      :checked="isChecked(item['ready_to_ship'])"
                      @click="(e) => onReadyToShip(e, item)"
                      :disabled="false"
                    />
                    <div class="checkmark"></div>
                  </div>
                </div>
              </td>

              <!-- <td v-bind="tdcon('options')" >
           
                <div class="dt-icon-container">
                  <img src="static/icons/delete.svg" @click.stop="(e) => deleteOrder(item)" class="dt-icon v5 s2" alt="Delete order" title="Delete order" />
                </div>
             
            </td> -->
            </tr>
          </template>
        </NTable>

        <div style="float: right; margin-top: 20px" class="ut-flex">
          <div id="distribution_orders_tab"></div>
          <button
            v-if="displayTransferOrderToWarehouseBtn"
            @click="onOrderToWarehouseClick"
            class="dt-button v5 s8"
          >
            {{ $t("transfer_to_warehouse") }}
          </button>
          <button
            style="min-width: 90px"
            :disabled="isEdiLoading"
            :class="{ disabled: isEdiLoading }"
            v-if="displayLoadEdiOrdersBtn"
            @click="onLoadEdiOrdersClick"
            class="dt-button v5 s8"
          >
            <template v-if="isEdiLoading">
              <img src="static/icons/loading.gif" />
            </template>
            <template v-else> {{ $t("load_edi_orders") }} </template>
          </button>
          <button @click="onAddMultiOrderClick" class="dt-button v5 s8">
           {{$t('multi_account_orders')}}
          </button>
        </div>
      </div>
      <ModalContainer :modalKey="'addMultiOrder'" :width="'medium'">
        <MultiAccountOrderModal @cancelled="onCancel" />
      </ModalContainer>
      <ModalContainer :modalKey="'addOrder'" :width="'small'">
        <AddOrder @added="onOrderAdded" @cancelled="onCancel" />
      </ModalContainer>

      <ModalContainer :modalKey="'showNotification'" :width="'small'">
        <NotificationModal @cancelled="onCancel" />
      </ModalContainer>
      <ModalContainer :modalKey="'addOrderLine'" :width="'medium3'">
        <AddOrderLineModal @added="onAddOrderLine" @cancelled="onCancel" />
      </ModalContainer>

      <ModalContainer :modalKey="'priceCodeDiscountModal'" :width="'small'">
        <DiscountModal @update="onUpdateOrderLine" @cancelled="onCancel" />
      </ModalContainer>

      <!-- <ModalContainer :modalKey="'documentsModal'" :width="'small'">
        <DocumentsModal @cancelled="onCancel" />
      </ModalContainer> -->

      <!-- <ModalContainer :modalKey="'bandCampModal'" :width="'large'">
        <BandCampModal :bandCampData="bandCampResponse" @cancelled="onCancel" />
      </ModalContainer> -->

      <ModalContainer :modalKey="'vatTerritoryModal'" :width="'small'">
        <VatTerritoryModal
          @changed="onOrderDetailsUpdated"
          @cancelled="onCancel"
        />
      </ModalContainer>
      <ModalContainer :modalKey="'dfileUploader'" :width="'medium'">
        <DFileUploader
          :instruction="instruction"
          @upload="onUploadFile"
          :allowedType="['xls', 'xlsx']"
          @cancelled="onCancel"
        />
      </ModalContainer>

      <ModalContainer :modalKey="'xlsxImport'" :width="'medium'">
        <XlsxImportModal :rows="xlsxRow" @cancelled="onCancel" />
      </ModalContainer>
      <!-- <ModalContainer :modalKey="'checkLabel'" :width="'medium2'">
        <CheckLabel @cancelled="onCancel" />
      </ModalContainer> -->

      <!-- <ModalContainer
      :modalKey="'accountDateModal'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <AccountDateModal @cancelled="onCancel" />
    </ModalContainer> -->

      <Sidewindow :value="orderDetailsFlag" @closed="onCloseOrderSidewindow">
        <OrderSideWindow
          v-if="orderDetailsFlag"
          :distributionOrderDetails="distributionOrderDetails"
        />
      </Sidewindow>

      <ModalContainer :modalKey="'advancedSearch'" :width="'420'">
        <AdvancedSearch
          :advancedSearchData="advancedSearchData"
          :initSearchFilter="searchFilter"
          @search="onAdvancedSearch"
          @cancelled="onDialogCancelled"
        />
      </ModalContainer>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
//plugins
import InputField from "@plugins/text-field/input-field";
import Dropdown from "@plugins/dropdown/dropdown";
import NTable from "@/plugins/datatable/datatable";
import DFileUploader from "@dtplugins/dfile-uploader/file-uploader";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import DatePicker from "@plugins/text-field/date-picker";
//dt-plugins
import { ConfirmationService } from "../../../../dt-plugins/confirmation/confirmation.service";
import Sidewindow from "../../../../dt-plugins/sidewindow/sidewindow";
import { createFetchListMixin } from "../../../../dt-plugins/advanced-search/fetch-list.mixin";
import {
  createModalMixin,
  closeModalRoute,
  openModalRoute,
  openModalRoute2,
} from "../../../../dt-plugins/modal/modal.mixin";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import ModalContainer from "@dtplugins/modal/modal-container";
//store
import { distributionOrderActions } from "../../store/orders/actions";
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/orders/types";

import { Subject } from "rxjs";

import { childOfOrEqual } from "../../../../router/functions";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import OrderSideWindow from "./order-sidewindow.vue";
import { distributionOrderGetters } from "../../store/orders/getters";

import { createTV } from "../../../../models/text-value.model";

//modal
import MultiAccountOrderModal from "./add-multi-account-orders.vue";
import AddOrder from "./add-order";
import NotificationModal from "./notification-modal.vue";
// import DocumentsModal from "./documents-modal.vue";
import BandCampModal from "./bandcamp-modal.vue";
import VatTerritoryModal from "./vat-territory-modal.vue";
import EdiOrderList from "./edi-order-list.vue";
import CheckLabel from "./catalaog.vue";
import { OrderService } from "../../services/order.service";
import {
  distributionOrderListLDTRoutes,
  getDistributionOrderDetailsSelectable,
} from "../../router/routes";

import {
  childOfOrEqualDetails,
  handleFromRoute,
  routeWithFrom,
} from "../../../../utility/route";
//component
import AddOrderLineModal from "./add-orderlines-modal.vue";

import DiscountModal from "./discount-modal.vue";
import { invoiceListLDTRoutes } from "../../../accounting/router/routes";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
import { MHTTPCL, HttpClient } from "../../../../services/http/http-client";

// import AccountDateModal from "./account-date-modal";
import { isChecked, openWindow, wait } from "../../../../utility";
import { DISTRIBUTION_URL } from "../../../../services/common-urls";
import BandCamp from "../../../../dt-plugins/module-plugins/bandcamp";
import { confirmMessage } from "@/dt-plugins/confirmation/confirmation-common";

import XlsxImportModal from "./xlsx-import-modal.vue";
import { createAdvancedSearchHost } from "../../../../dt-plugins/advanced-search/advance-search.mixin";
import { orderListAdvancedSearchConfig } from "./advanced-search.vue";
import AdvancedSearch from "./advanced-search";
import { getMonthYearTVsFromMinMaxObject } from "../../../../utility/calendar";

const LDTConfig = {
  entityName: "order",
  ldtRoutes: distributionOrderListLDTRoutes,
  detailsSelectableFunction: getDistributionOrderDetailsSelectable,
  primaryKey: "order_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.DistributionOrderDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.DistributionOrderDetails.FETCH.SINGLE,
};

export default {
  mounted: async function () {
    const orderData = await OrderService.ordershome();
    this.orderData = orderData.data;
  },

  components: {
    InputField,
    NTable,
    DatePicker,
    OrderSideWindow,
    Sidewindow,
    ModalContainer,
    MultiAccountOrderModal,
    AddOrder,
    NotificationModal,
    AddOrderLineModal,
    DiscountModal,
    // DocumentsModal,
    BandCampModal,
    VatTerritoryModal,
    DFileUploader,
    BandCamp,
    EdiOrderList,
    CheckLabel,
    XlsxImportModal,
    AdvancedSearch,
  },
  data() {
    return {
      xlsxRow: [],
      instruction:
        "Only xls/xlsx file format supported. valid column headers are: barcode catalog no artist OR release artist title OR release title release type format qty",
      orderData: null,
      orderTableConfig: createNTableConfig({
        scrollNextThreshold: 95,
        rowHeight: 40,
      }),
      shippedList: [
        { text: "all", value: "all" },
        { text: "shipped", value: "shipped" },
        { text: "not shipped", value: "not shipped" },
      ],
      accountedList: [
        { text: this.$t("accounted"), value: "accounted" },
        { text: this.$t("not_accounted"), value: "not accounted" },
        { text: this.$t("today"), value: "current_day" },
        { text: this.$t("this_week"), value: "current_week" },
        { text: this.$t("this_month"), value: "current_month" },
        { text: this.$t("ready_to_ship"), value: "ready_to_ship" },
      ],
      searchString: "",
      searchSubject$: new Subject(),
      selectedClickedOrder: null,
      showEdiOrderList: false,
      loadingGif: true,
      isEdiLoading: false,
      loadingEdiFlag: false,
      ediOrderTabs: [],
      selectedEdiOrderTab: {},
      searchModel: {
        searchString: "",
        order_month: "",
        accounted_period: "",
        account_id: 0,
        status: "",
        is_shipped: null,
        shipping_date: null,
      },
    };
  },
  mixins: [
    createModalMixin("addMultiOrder"),
    createModalMixin("addOrder"),
    createModalMixin("showNotification"),
    createModalMixin("addOrderLine"),
    createModalMixin("priceCodeDiscountModal"),
    createModalMixin("documentsModal"),
    // createModalMixin("pickStatusModal"),
    createModalMixin("bandCampModal"),
    createModalMixin("vatTerritoryModal"),
    createModalMixin("dfileUploader"),
    createModalMixin("checkLabel"),
    createModalMixin("xlsxImport"),
    // createModalMixin("accountDateModal"),
    createLDTHost(LDTConfig),

    createFetchListMixin(ActionTypes.DistributionOrderList.FETCH.ALL, 100),
    createModalMixin("advancedSearch"),
    createAdvancedSearchHost(orderListAdvancedSearchConfig),
  ],
  computed: {
    ...mapGetterObject(storeNS, distributionOrderGetters),
    output: function () {
      return eval(
        "<div><p>Lorem ipsum dolor sit amet.</p><p><i>Lorem ipsum!</i></p></div>"
      );
    },
    displayTransferOrderToWarehouseBtn: function () {
      return this.orderData?.display_transfer_order_to_warehouse_btn || false;
    },
    displayLoadEdiOrdersBtn: function () {
      return this.orderData?.display_load_edi_orders_btn || false;
    },

    list: function () {
      return this.distributionOrderList?.orders || [];
    },
    shipmentSettingsKey: function () {
      return (
        Object.keys(this.distributionOrderList?.shipment_settings || {})[0] ||
        ""
      );
    },
    shipmentSettings: function () {
      return this.distributionOrderList?.shipment_settings || {};
    },
    monthsTV: function () {
      console.log(
        ":::TV",
        this.distributionOrderList?.order_dates.max_date.getFullYear()
      );
      if (this.distributionOrderList?.order_dates) {
        const maxDate = new Date(
          this.distributionOrderList?.order_dates.max_date
        );
        const minDate = new Date(
          this.distributionOrderList?.order_dates.min_date
        );
        const maxYear = maxDate.getFullYear() || 0;
        const minYear = minDate.getFullYear() || 0;
        let minMonth = minDate.getMonth() || 0;
        let maxMonth = maxDate.getMonth() || 0;
        let minYearSecond = minYear + 1;
        let minMonthSecond = 0;
        const monthName = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];

        console.log("::::", minMonth, minYearSecond);
        const monthArray = [
          ...[...Array(12 - minMonth).keys()].map((e) => {
            const curValue = {
              text: `${monthName[minMonth++]} ${minYear}`,
              value: `${minYear}-${minMonth}`,
            };

            return curValue;
          }),
          ...[...Array(12 - maxMonth).keys()].map((e) => {
            const curValue = {
              text: `${monthName[maxMonth++]} ${maxYear}`,
              value: `${maxYear}-${maxMonth}`,
            };

            return curValue;
          }),
          ...[...Array((maxYear - minYear - 1) * 12).keys()].map((e) => {
            if (minMonthSecond > 11) {
              minMonthSecond = 0;
              minYearSecond++;
            }
            const curValue = {
              text: `${monthName[minMonthSecond++]} ${minYearSecond}`,
              value: `${minYearSecond}-${minMonthSecond}`,
            };

            return curValue;
          }),
        ];

        return monthArray;
      } else {
        return [];
      }
    },

    accountsTV: function () {
      return createTV(
        this.distributionOrderList?.accounts,
        "account_name",
        "account_id"
      );
    },
    orderStatusTV: function () {
      return createTV(
        this.distributionOrderList?.order_status,
        "value",
        "value"
      );
    },

    orderDetailsFlag: function () {
      return childOfOrEqualDetails(distributionOrderListLDTRoutes, this.$route);
    },
    headers: function () {
      return [
        createTableHeader("order_date", { mw: 100 }),
        createTableHeader("order_id"),
        createTableHeader("account_name"),
        createTableHeader("reference"),
        createTableHeader("status1", { text: "status" }),
        createTableHeader("source", { text: "source" }),
        createTableHeader("account_date", { text: "Account Date", mw: 110 }),
        createTableHeader("invoice", {}),

        createTableHeader("order_value", { text: false, ta: "right" }),
        createTableHeader("options", { text: "Shipping", mw: 80 }),
        createTableHeader("ready_to_ship", { text: false, mw: 50 }),
      ];
    },
    advancedSearchData: function () {
      console.log({
        "order-list.vue:643 Dates": getMonthYearTVsFromMinMaxObject(
          this.advancedSearchResponse?.order_dates
        ),
      });
      return {
        accountsTV: this.accountsTV,
        // accountsTV: this.advancedSearchResponse?.accounts || [],
        orderStatusTV: this.orderStatusTV,

        accountedTV: this.accountedList,
        monthsTV: getMonthYearTVsFromMinMaxObject(
          this.advancedSearchResponse?.order_dates
        ),
        shippedTV: [
          {
            text: this.$t("shipped"),
            value: "shipped",
          },
          {
            text: this.$t("not_shipped"),
            value: "not_shipped",
          },
        ],
      };
    },
    filter: function () {
      return {
        ...this.metaFilter,
        basicFilter: this.basicFilter,
        searchFilter: this.searchFilter,
      };
    },
  },

  created() {},

  methods: {
    ...mapActionObject(storeNS, distributionOrderActions),
    onOrderToWarehouseClick: async function () {
      const confirmationResult = await confirmMessage(
        this.$t("status_update_confirmation_message"),
        this.$t("transfer_to_warehouse_change_order_status_confirmation")
      );
      if (confirmationResult === "OK") {
        window.open(
          `${HttpClient.getBaseUrl()}/distribution.pl?section=orders&action=transfer_to_warehouse_report`,
          "_blank"
        );
      }
    },
    checkPlaugin() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "check_label",
        },
      });
    },
    onLoadEdiOrdersClick: async function () {
      this.isEdiLoading = true;
      const res = await OrderService.loadEdiOrders();
      const res1 = await OrderService.getFilteredOrderList({
        searchString: "",
        order_month: "",
        accounted_period: "",
        account_id: "",
        status: "",
        is_shipped: "all",
        shipping_date: "",
        start: 0,
        filterEmpty: true,
      });
      const { orders, edi_order_status } = res1.data;
      this[ActionTypes.DistributionOrderList.SET.ALL]({ orders: orders });
      const { has_config } = res.data;
      if (!has_config) {
        NotificationService.showNotification({
          text: "Api config missing",
          timeout: 2000,
          type: "warning",
        });
      } else {
        this.isEdiLoading = false;
        NotificationService.showNotification({
          text: "Load EDI orders process completed",
          timeout: 2000,
          type: "normal",
        });
      }
    },
    onEdiListLoad: async function (e) {
      this.showEdiOrderList = e;
      this.loadingEdiFlag = true;
      if (e) {
        const res = await OrderService.getFilteredOrderList({
          searchString: "",
          order_month: "",
          accounted_period: "",
          account_id: "",
          status: "",
          is_shipped: "all",
          shipping_date: "",
          start: 0,
          filterEmpty: true,
          edicot_only: 1,
        });
        let { orders, edi_order_status } = res.data;
        orders = orders.map((o) => {
          o = {
            ...o,
            ...o.json_data.edi_order,
          };
          return o;
        });
        this.loadingEdiFlag = false;
        this.selectedEdiOrderTab = {
          orders: orders,
          edi_order_status: edi_order_status,
          tabName: "Name",
        };
      }
    },
    onCancel: function () {
      closeModalRoute(this);
    },
    defaultBasicFilter() {
      //<-- Needed for BasicSearch. Provide the basic Filter Object. Supports String/Boolean/Number
      return {
        searchString: undefined,
        order_month: undefined,
        accounted_period: undefined,
        account_id: undefined,
        status: undefined,
        is_shipped: undefined,
        shipping_date: undefined,
      };
    },
    onListScroll: function (value) {
      console.log("OOO");
      this.scrollSubject.next(value);
    },
    onAddOrderClick: function () {
      console.log("onAddOrderClick");
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_order",
        },
      });
    },
    async fetch() {
      const pluginData = await MHTTPCL.post("/plugins.pl", {
        section: "plugins",
        action: "plugin_code",
        plugin_id: 318,
      });
      this.pluginData = pluginData.data;
      console.log("this.pluginData", this.pluginData);
    },

    onWindowMessage(event) {
      const postData = JSONX.tryParse(event.data);
      console.log("Log: onWindowMessage -> event.data", event.data, postData);
      if (postData.success) {
        if (postData.result.message == "close") {
          console.log("onCancel");
          this.onCancel();
        }
      }
    },
    onOrderAdded: async function (order) {
      console.log("::::", order);

      const orderAddedRes = await OrderService.addOrder(order);

      if (orderAddedRes.data.new_order_id) {
        NotificationService.showNotification({
          text: "Order added successfully",
          timeout: 2000,
          type: "normal",
        });

        this.$router.push({
          name: distributionOrderListLDTRoutes.names.tab,
          params: {
            order_id: orderAddedRes.data.new_order_id,
            tab: "overview",
          },
        });

        this.fetchListReset();
        this.selectedClickedOrder = orderAddedRes.data.orders?.find(
          (e) => +e.order_id === +orderAddedRes.data.new_order_id
        );
        console.log({
          "order-list.vue:853 this.selectedClickedOrder":
            this.selectedClickedOrder,
        });
      } else {
        NotificationService.showNotification({
          text: "Some issue. Please contact with support",
          timeout: 2000,
          type: "error",
        });
      }

      // const insertedOrder = await this[
      //   ActionTypes.DistributionOrderList.INSERT.SINGLE
      // ](order);
      // console.log(insertedOrder, "::::::::insertedOrder");
      // await this.onCancel();
      // this.onRowClicked(insertedOrder);
    },
    onAddMultiOrderClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_multi_order",
        },
      });
    },
    onSearchInputKeyup(event) {
      this.searchString = event.target.value;
      console.log(this.searchString);
      this.basicFilter.searchString = this.searchString;
      this.fetchListReset();
    },

    selectedRow: function (order) {
      return (
        this.selectedClickedOrder &&
        this.selectedClickedOrder["order_id"] == order["order_id"]
      );
    },
    onRowClicked: function (order) {
      this.selectedClickedOrder = order;
      this.$router.push({
        name: distributionOrderListLDTRoutes.names.tab,
        params: {
          order_id: order.order_id,
          tab: "overview",
        },
      });
    },
    onCloseOrderSidewindow: function () {
      this.selectedClickedOrder = null;
      this.fetchListReset();
      handleFromRoute(this, () => {
        this.$router.push({
          name: distributionOrderListLDTRoutes.names.list,
        });
      });
    },

    onDateChange: function (payload) {
      const { name, value } = payload;
      this.basicFilter[name] = value;
      this.fetchListReset();
    },
    onDropdownChange(action, data) {
      console.log(action, data, this.accountsTV);
      this.basicFilter[action] = data.value;
      this.fetchListReset();
    },

    onClickBandCamp: async function (e) {
      console.log(" e.bandCampResponse", e.bandCampResponse);
      await this[ActionTypes.DistributionOrderList.SET.SINGLE](
        e.bandCampResponse
      );
      if (this.bandCampResponse.ordersArray.length > 0) {
        openModalRoute2(this, "bandCampModal");
      } else {
        NotificationService.showNotification({
          text: "Currently there are no new orders.Checking again ...",
          timeout: 2000,
          type: "normal",
        });
      }
    },
    onAddOrderLine: async function ({ order_id }) {
      // this[ActionTypes.DistributionOrderOrderLine.INSERT.MULTIPLE](payload);
      // this[ActionTypes.DistributionOrderOrderLine.FETCH.ALL](payload);

      // Refetch the Order Object

      await this[ActionTypes.DistributionOrderDetails.FETCH.PARTIAL]({
        order_id: order_id,
        properties: ["order_details_tab_summary", "packing_orderlines"],
      });
    },

    onUpdateOrderLine: function (payload) {
      this[ActionTypes.DistributionOrderOrderLine.UPDATE.MULTIPLE](payload);
      this.onCancel();
    },

    onClickInvoiceRef: function (item) {
      // console.log({'order-list.vue:690 item' : item});
      routeWithFrom(this, {
        name: `invoices/invoice_id/tab`,
        params: {
          invoice_id: item?.invoice_id,
          tab: "overview",
        },
      });
    },

    onShipmentClick: async function (item) {
      const { order_id } = item;
      NotificationService.showNotification({
        text: "Sending Request",
        timeout: 2000,
        type: "normal",
      });
      const res = await OrderService.shippingNotify(
        order_id,
        "0",
        this.shipmentSettingsKey
      );

      if (!res) {
        NotificationService.showNotification({
          text: "Some issue. Please contact with support",
          timeout: 2000,
          type: "error",
        });
      }
    },
    fillBandCamp: async function () {
      const bandCampData = await OrderService.getOrdersFromBandcamp();

      console.log(bandCampData, "bandCampData");

      // console.log(JSON.parse("{\"193\":{\"orders\":{\"95778447\":{\"orderlines\":[{\"order_qty\":1,\"vat_rate\":null,\"import_artist\":\"Kiwi\",\"ppu\":12.9,\"external_table\":\"product\",\"import_title\":\"Hello+Echo:+Kompakt+423+12\\\"+by+Kiwi\",\"identifier\":\"K-HE-K423\",\"external_id\":2162}],\"account_id\":180,\"deliver_name\":\"Michael+GILBERT\",\"deliver_postalcode\":\"WD7+8HB\",\"order_reference\":\"95778447\",\"bandcamp_client_id\":\"193\",\"contra_account_id\":190,\"shipping_type_id\":1,\"bandcamp_order_date\":\"25+Apr+2022…\":null,\"order_qty\":1,\"import_artist\":\"Kuniyuki+Takahashi\",\"ppu\":14.5,\"external_table\":\"product\",\"external_id\":2162,\"identifier\":\"Mule+Musiq+271\",\"import_title\":\"Remix+Works+Sampler:+Mule+Musiq+271+Vinyl+12\\\"+by+Kuniyuki+Takahashi\"}],\"deliver_name\":\"Ashley+Turner\",\"account_id\":180,\"deliver_postalcode\":\"0604\",\"order_reference\":\"4261872625\",\"bandcamp_client_id\":\"193\",\"contra_account_id\":190,\"shipping_type_id\":1}},\"start_date_time\":\"28+Apr+2022+07:30:01+GMT\"}}"));

      const objKeyArray = Object.keys(bandCampData.data.response);
      console.log("bandCampData :::", objKeyArray);
      const objKey = objKeyArray[0];
      let bandCampResponse = { ...bandCampData.data.response[objKey] };
      bandCampResponse = {
        ...bandCampResponse,
        ordersArray: [...Object.values(bandCampResponse.orders)],
      };
      console.log(bandCampResponse, "bandCampData");
      this.loadingGif = false;

      await this[ActionTypes.DistributionOrderList.SET.SINGLE](
        bandCampResponse
      );
    },

    onOrderDetailsUpdated: function (payload) {
      console.log(":::");
      this[ActionTypes.DistributionOrderDetails.UPDATE.SINGLE]({ ...payload });
      this.onCancel();
    },

    onUploadFile: async function (payload) {
      // console.log("::: Payl", payload);
      const formData = new FormData();
      formData.append("action", "porcess_xls_order_import_file");
      formData.append("section", "orders");
      formData.append("file_name", payload.file);

      // formData.append("returnType", "json");
      // formData.append("output", "json");

      // If a Order Sidewindow is not open, then Wrong Modal Placement
      if (!this.$route.params?.order_id) {
        return;
      }

      const order_id = this.$route.params?.order_id;

      formData.append("order_id", order_id);

      // console.log({'order-list.vue:994 formData' : formData});

      const resData = await MHTTPCL.postFormData(DISTRIBUTION_URL, formData);

      this.xlsxRow = resData.data.rows;
      console.log({ "order-list.vue:999 this.xlsxRow": this.xlsxRow });

      if (resData.data?.process_all === "no") {
        this.$router.push({
          ...this.$route,
          query: {
            modal: "xlsx_import",
            order_id: order_id,
          },
        });
      } else {
        this.onCancel();
      }

      console.log(":::::::::::^^^^^", ":::", resData);

      // Wait 3s for the Backend to Properly Load the New Orderlines
      // await wait(5000);

      this[ActionTypes.DistributionOrderOrderLine.FETCH.ALL]({
        order_id,
      });
      this[ActionTypes.DistributionPackageLine.FETCH.ALL]({
        order_id,
      });
    },

    isChecked: isChecked,
    onReadyToShip(e, item) {
      const value = e.target.checked;
      this[ActionTypes.DistributionOrderList.UPDATE.SINGLE]({
        item,
        name: "ready_to_ship",
        value: value ? 1 : 0,
      });
    },
    onAdvancedSearchClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "advanced_search",
        },
      });
    },
    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    fetchAdvancedSearchData: async function () {
      const advancedSearchData = await OrderService.fetchAdvancedSearchData();
      console.log({
        "order-list.vue:1009 advancedSearchData": advancedSearchData,
      });
      this.advancedSearchResponse = advancedSearchData.data;
      console.log({
        "this.advancedSearchResponse": this.advancedSearchResponse,
      });
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss" scoped>
.cmp-distribution-orders-order_list {
  .dt-ntable.order_list {
    --ntable-height: calc(100vh - 185px);

    @media (min-width: 320px) and (max-width: 480px) {
      th:nth-child(2),
      td:nth-child(2),
      th:nth-child(3),
      td:nth-child(3),
      th:nth-child(4),
      td:nth-child(4),
      th:nth-child(7),
      td:nth-child(7) {
        display: none;
      }
    }

    td.account_name {
      font-weight: 800 !important;
    }

    td.options {
      .option-buttons {
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  // button {
  //   float: right;
  //   height: 2.5em;

  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   transition: all 0.3s ease;
  //   border-radius: 5px;
  // }
  .order-top-bar {
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;

    & > div {
      margin: 0px 10px;
    }

    // .add-button {
    //   flex: 0.4;
    //   padding: 5px;
    //   display: flex;
    //   justify-content: center;
    // }
    // .search {
    //   flex: 2;
    // }
    // .users-dropdown {
    //   flex: 2;
    // }
    .right-space {
      flex: 8;
    }

    .dropdown {
      //flex: 5;
      width: 180px;
      min-width: 220px;
      margin: 0px 10px;
    }

    .input-field-container {
      //flex: 5;
      width: 180px;
      max-width: 200px;
      margin: 0px 10px;
    }
  }

  iframe {
    width: 50px;
    height: 50px;
  }
}
</style>